<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-beach">
<h1>The Beach</h1>
<p><strong>T</strong>ourists gather to these meccas of the shore,</p>
<p><strong>H</strong>ot spots for life, both human and animal,</p>
<p><strong>E</strong>veryone loves a sunny day, full of fun, water and peace.</p><br/>
<p><strong>B</strong>eautiful places, wonderful views,</p>
<p><strong>E</strong>xtraordinary animals gathering under the waves,</p>
<p><strong>A</strong> masterpiece of God’s creation, cradling life in abundance,</p>
<p><strong>C</strong>rashing waves, calm bays, serene headlands,</p>
<p><strong>H</strong>osting fish, whales, dolphins, turtles, plants and people, all happily playing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?13ddb120